
import { DocumentLayoutHeading } from "@/utils/documents/layout-heading";
import { DocumentPageSettings } from "@/utils/documents/page-settings";
import { TranslatedStyledProperty } from "@/utils/documents/translated-styled-property";
import Vue from "vue";
import AppDraggableResizeCombo from "./DraggableResizeCombo.vue";

export default Vue.extend({
	props: {
		heading: {
			type: Object as () => DocumentLayoutHeading,
			required: true
		},
		pageSettings: Object as () => DocumentPageSettings,
		headingHeight: Number,
		lang: String
	},
	computed: {
		props(): (keyof DocumentLayoutHeading)[] {
			let items = [] as (keyof DocumentLayoutHeading)[];
			for (let i = 0; i < 9; i++) {
				items.push("Heading" + (i + 1) as keyof DocumentLayoutHeading);
			}
			return items;
		},
		styles(): any {
			let obj = {} as any;
			for (let prop of this.props) {
				obj[prop] = ((this.heading as any)[prop] as TranslatedStyledProperty).Style.getStyle();
			}
			return obj;
		}
	},
	methods: {
		getSafeHtmlOfHeading(headingNum:keyof DocumentLayoutHeading):string{
			return (this.heading[headingNum] as TranslatedStyledProperty).Value.getTranslation(this.lang);
		}
	},
	components: {
		AppDraggableResizeCombo,
	}
});
